<template>
  <v-card color="white" class="mx-auto" :disabled="loading" :loading="loading">
    <v-card-title>
      <h1>{{ $t("drawer.graduate_officer_menu") }}</h1>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col md="6">
          <v-list>
            <v-subheader>เมนูในระบบใหม่</v-subheader>
            <v-list-item
              v-for="(item, i) in menu_list"
              :key="i"
              :value="item"
              :to="item.to"
              color="primary"
            >
              <v-list-item-icon>
                <v-icon>mdi-square-medium</v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item>
          </v-list>
        </v-col>
        <v-col md="6">
          <v-list>
            <v-subheader>เมนูในเก่า</v-subheader>
            <v-list-item
              v-for="(item, i) in menu_list_old_system"
              :key="i"
              :value="item"
              :href="item.to"
              color="primary"
            >
              <v-list-item-icon>
                <v-icon>mdi-circle-medium</v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "Profile",
  data: () => ({
    loading: false,
    menu_list: [
      {
        to: "/config_graduate_curriculum_fee",
        text: "กำหนดรายละเอียดค่าธรรมเนียมการศึกษา",
      },
      {
        to: "/config_graduate_separate_thesis_credit",
        text: "กำหนดจำนวนหน่วยกิตวิชาวิทยานิพนธ์",
      },
      {
        to: "/report_student_not_registered",
        text: "รายงานนักศึกษาที่ยังไม่ลงทะเบียน + บันทึกรักษาสภาพ",
      },
    ],
    menu_list_old_system: [
      {
        to: `https://www${process.env.VUE_APP_ENV !== "production" ? "-staff" : ""}.reg.kmitl.ac.th/index?f=u_officer_x`,
        text: "เมนูหลัก",
      },
      {
        to: `https://www${process.env.VUE_APP_ENV !== "production" ? "-staff" : ""}.reg.kmitl.ac.th/index?f=advance`,
        text: "เมนู 4+1",
      },
    ],
  }),
};
</script>

<style scoped>
.home {
  text-align: center;
  padding: 2rem;
}
</style>
